import { computeEntityTimestamps } from '@app/styles/frontend/utils/entity-timestamps';
import { ModuleFE_DiseaseProfile, ModuleFE_DiseaseValue, ModuleFE_MultiVar } from '../_entity.js';
/**
 * created = disease-profile.__created
 * lastEdited = max(__updated) across the disease-profile and all its multi-vars and disease-values
 */
export const getDiseaseProfileTimestamps = (dpId) => {
    const dp = ModuleFE_DiseaseProfile.cache.unique(dpId);
    if (!dp)
        return undefined;
    const multiVars = ModuleFE_MultiVar.cache.filter(mv => mv.diseaseProfileId === dpId);
    const diseaseValues = ModuleFE_DiseaseValue.cache.filter(dv => dv._diseaseProfileId === dpId);
    return computeEntityTimestamps(dp, multiVars, diseaseValues);
};
//# sourceMappingURL=disease-profile-timestamps.js.map